import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  header: {
    color: 'var(--text-secondary)',
    padding: '0 0 8px 0',
    fontSize: '13px',
    lineHeight: '19.56px',

    '@media screen and (min-width: 1441px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
}));

export default useStyles;
